import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

const options = {
    theme: {
        primary: '#ee44aa',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
        dark: false
    },
    customProperties: true,
    iconfont: 'mdi'
};
Vue.use(Vuetify);
export default new Vuetify(options)
